module.exports = __webpack_public_path__ + "img/slide-14-3.609672d7.jpg";